import { useEffect, useState } from "react";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";
import moment from "moment";
import "../List.scss";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { Popover, Popconfirm } from "antd";
import { abreviarNome } from "../../../../../../shared/util/helperFunctions";

const CONSENTIMENTO_LABELS = {
  sms_lembretes: "SMS de lembretes",
  email_lembretes: "Emails de lembretes",
  email_promocional: "Emails promocionais",
  sms_promocional: "SMS promocionais",
  partilha_documentos: "Partilha de documentos por email",
  tcle: "TCLE — Termo de Consentimento Livre Esclarecido",
};

function ListConsentimentos({ data, handleDesativar, verPdfConsentimento }) {
  const [consentimentos, setConsentimentos] = useState(data);

  useEffect(() => {
    setConsentimentos(data);
  }, [data]);

  let content = [];
  if (consentimentos) {
    consentimentos.forEach((row) => {
      content.push(
        <div className="dots__menu__popup">
          <Popconfirm
            title="Desativar consentimento"
            description="Tem a certeza que pretende desativar este consentimento?"
            icon={<DeleteIcon style={{ color: "red" }} />}
            okText="Sim"
            cancelText="Não"
            onConfirm={handleDesativar.bind(null, row.id)}
          >
            <div className="popOverMenu--option">
              <span>Desativar</span>
              <DeleteIcon className="popOverMenu--option__icon" />
            </div>
          </Popconfirm>
        </div>,
      );
    });
  }

  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{ background: "#fff" }}>
          <TableRow>
            <TableCell className="tableCell tableCell--heading">
              Criado por
            </TableCell>
            <TableCell className="tableCell tableCell--heading">
              Consentimentos
            </TableCell>
            <TableCell className="tableCell tableCell--heading">
              Data de Criação
            </TableCell>
            <TableCell className="tableCell tableCell--heading">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        {consentimentos && (
          <TableBody>
            {consentimentos.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell className="tableCell">
                  {abreviarNome(row.criadoPor.name)}
                  <BadgeUnidade estabelecimento={row.estabelecimento} />
                </TableCell>
                <TableCell className="tableCell">
                  {row.consentimentos
                    .map((c) => CONSENTIMENTO_LABELS[c] || c)
                    .join(", ")}
                </TableCell>
                <TableCell className="tableCell">
                  {moment(row.created_at).format("DD-MM-YYYY / HH:mm")}
                </TableCell>
                <TableCell className="tableCell">
                  <div className="botoes-action">
                    <Tooltip title="Gerar PDF">
                      <PictureAsPdfOutlinedIcon
                        className="action-button-with-tooltip"
                        onClick={() => verPdfConsentimento(row.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    {content[index] && (
                      <Popover
                        content={content[index]}
                        trigger="click"
                        placement="bottom"
                      >
                        <div className="dots__menu">
                          <div className="dot"></div>
                          <div className="dot"></div>
                          <div className="dot"></div>
                        </div>
                      </Popover>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}

export default ListConsentimentos;
